import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './saga';
import assetSlice from './services/controllers/asset/AssetSlice';
import bookSlice from './services/controllers/book/BookSlice';
import commonSlice from './services/controllers/common/CommonSlice';
import folderSlice from './services/controllers/folder/FolderSlice';
import imageSlice from './services/controllers/image/ImageSlice';
import orderSlice from './services/controllers/order/OrderSlice';
import userSlice from './services/controllers/user/UserSlice';
import eventsSlice from './services/controllers/events/EventsSlice';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['common', 'user', 'book', 'image', 'folder', 'asset', 'order'],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    common: commonSlice,
    user: userSlice,
    book: bookSlice,
    image: imageSlice,
    folder: folderSlice,
    asset: assetSlice,
    order: orderSlice,
    events: eventsSlice,
  }),
);

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
  devTools: import.meta.env.DEV,
});

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
